import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=3159e02c"
import script from "./leftSidebar.vue?vue&type=script&lang=js"
export * from "./leftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports